import { z } from 'zod';
import { ClinicalAidType, CprMetronomeSettings } from '../constants/clinical.constants';
import { RemoteCommandType } from '../constants/webrtc.constants';

export const RemoteCommandPayloadSchema = z.object({
  command: z.nativeEnum(RemoteCommandType),
  zoomValue: z.number().min(1).max(10).optional(),
  metronomeBpm: z
    .number()
    .int()
    .min(CprMetronomeSettings.MIN_BPM)
    .max(CprMetronomeSettings.MAX_BPM)
    .optional()
});

export const ClinicalAidPayloadSchema = z.object({
  aidType: z.nativeEnum(ClinicalAidType),
  title: z.string().min(1),
  shortInstructions: z.array(z.string().min(1)),
  recommendedBpm: z.number().int().optional(),
  iconName: z.string()
});

export const WhiteboardPointSchema = z.object({
  x: z.number().min(0).max(1), // Coordenada normalizada 0..1 para independencia de resolución
  y: z.number().min(0).max(1)
});

export const WhiteboardStrokeSchema = z.object({
  points: z.array(WhiteboardPointSchema).min(1),
  color: z.string().regex(/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/, 'Color hex inválido'),
  lineWidth: z.number().min(1).max(20)
});

export const WhiteboardPayloadSchema = z.object({
  snapshotId: z.string().uuid(),
  snapshotBase64: z.string().optional(), // Snapshot opcional si se envía con la imagen de fondo
  strokes: z.array(WhiteboardStrokeSchema),
  timestamp: z.number().int().positive()
});

export type RemoteCommandPayload = z.infer<typeof RemoteCommandPayloadSchema>;
export type ClinicalAidPayload = z.infer<typeof ClinicalAidPayloadSchema>;
export type WhiteboardPoint = z.infer<typeof WhiteboardPointSchema>;
export type WhiteboardStroke = z.infer<typeof WhiteboardStrokeSchema>;
export type WhiteboardPayload = z.infer<typeof WhiteboardPayloadSchema>;
